import {
  DEFAULT_COUNTRY_CODE,
  DEFAULT_REGION,
  REGION_COUNTRY_CODES,
  REGION_FALLBACK_CURRENCY,
  REGIONS,
  STORES,
  UK_COUNTRY_CODES,
  type Region,
  type RegionInfo,
  type Store,
} from '~/common/constants/region';
import { getCurrencySymbol } from '~/common/utils/currency';

export function resolveRegionInfo(countryCode: string | null): RegionInfo {
  if (!countryCode) {
    return { region: DEFAULT_REGION, countryCode: DEFAULT_COUNTRY_CODE };
  }

  const code = countryCode.toUpperCase();

  for (const [region, codes] of Object.entries(REGION_COUNTRY_CODES)) {
    if (codes.has(code)) {
      return { region: region as Region, countryCode: code };
    }
  }

  return { region: DEFAULT_REGION, countryCode: DEFAULT_COUNTRY_CODE };
}

export function isValidRegion(value: unknown): value is Region {
  return Object.values(REGIONS).includes(value as Region);
}

/** Collapses any (region, country) — a store code or a legacy per-country cookie — onto its store. */
export function toStore(region: Region, countryCode: string): Store {
  if (region === REGIONS.EU) return STORES.EU;
  if (region === REGIONS.US) return STORES.US;
  return UK_COUNTRY_CODES.has(countryCode.toUpperCase())
    ? STORES.UK
    : STORES.ROW;
}

export function getStoreLabel({ label, region }: Store): string {
  return `${label} / ${getCurrencySymbol(REGION_FALLBACK_CURRENCY[region])}`;
}
